
export const scrollSnapType = {
  name: 'scroll-snap-type'
}

export const scrollSnapAlign = {
  name: 'scroll-snap-align'
}
